import Resource from '@/api/core/resource'

class Recibo extends Resource {
  constructor () {
    super('tesoreria/recibos')
  }

  buscarComprobantesParaCancelar (datos) {
    return this.request.post(
      this.uri
        .concat('/buscar-comprobantes-cancelar'),
      datos
    )
  }

  obtenerDetalleComprobantes (reciboId, filtros) {
    return this.request.post(this.uri.concat('/').concat(reciboId).concat('/detalle-comprobantes'), filtros)
  }

  obtenerPagos (reciboId) {
    return this.request.get(this.uri.concat('/').concat(reciboId).concat('/pagos'))
  }

  guardarPago (reciboId, data) {
    if (typeof data.id !== 'undefined' && data.id) {
      return this.request.put(this.uri.concat('/').concat(reciboId).concat('/pagos/').concat(data.id), data)
    } else {
      return this.request.post(this.uri.concat('/').concat(reciboId).concat('/pagos'), data)
    }
  }

  eliminarPago (reciboId, id) {
    return this.request.delete(this.uri.concat('/').concat(reciboId).concat('/pagos/').concat(id))
  }
}

export default new Recibo()
